import { render, staticRenderFns } from "./ModalOpcaoInstitucional.vue?vue&type=template&id=c1963394&scoped=true"
import script from "./ModalOpcaoInstitucional.vue?vue&type=script&lang=js"
export * from "./ModalOpcaoInstitucional.vue?vue&type=script&lang=js"
import style0 from "./ModalOpcaoInstitucional.vue?vue&type=style&index=0&id=c1963394&prod&scoped=true&lang=css"
import style1 from "./ModalOpcaoInstitucional.vue?vue&type=style&index=1&id=c1963394&prod&lang=css"
import style2 from "./ModalOpcaoInstitucional.vue?vue&type=style&index=2&id=c1963394&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1963394",
  null
  
)

export default component.exports